// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   agencydashboard.css  -  every class is prefixed with "agencyDash-"
   Replace the WHOLE old agencydashboard.css with this file.
   ===================================================================== */

/* ---------- page shell ---------- */
.agencyDash-page {
  background: #fff;
  max-height: 90vh;
  overflow-y: auto;
  padding: 20px;
  font-family: Inter, "Poppins", sans-serif;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.agencyDash-page::-webkit-scrollbar { display: none; }

.agencyDash-page-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 16px 4px;
  font-size: 15px;
  font-weight: 700;
  color: #111;
}
.agencyDash-page-title img { width: 24px; height: 24px; }

.agencyDash-loader {
  margin: 80px auto;
  width: 46px;
  height: 46px;
  border: 5px solid #dbe6f5;
  border-top-color: #2563b0;
  border-radius: 50%;
  animation: agencyDash-spin 0.8s linear infinite;
}
@keyframes agencyDash-spin { to { transform: rotate(360deg); } }

/* ---------- filter bar ---------- */
.agencyDash-filter-bar {
  position: relative;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px 28px;
  padding: 22px 26px;
  margin-bottom: 18px;
justify-content: center;
  background: linear-gradient(90deg, #0b5cab 0%, #073c80 55%, #04295f 100%);
}
.agencyDash-filter-group { display: flex; align-items: center; gap: 10px; }
.agencyDash-filter-label {
  margin: 0;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* ---------- stat cards ---------- */
.agencyDash-card-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 18px;
}

.agencyDash-card {
  --c: #2563b0;
  --bg: #eef3fa;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  min-height: 138px;
  padding: 16px 18px 18px;
  border: 1.5px solid var(--c);
  border-radius: 14px;
  background: var(--bg);
  box-sizing: border-box;
}
.agencyDash-card--tall { flex: 1 1; min-height: 150px; }

.agencyDash-card--blue   { --c: #2563b0; --bg: #eef3fa; }
.agencyDash-card--purple { --c: #8e3fa8; --bg: #f6f0fa; }
.agencyDash-card--orange { --c: #e07a1a; --bg: #fdf7ee; }
.agencyDash-card--green  { --c: #22a05a; --bg: #eaf6ee; }
.agencyDash-card--pink   { --c: #c23a7c; --bg: #fbeaf1; }
.agencyDash-card--indigo { --c: #2b3a8f; --bg: #e8ebf9; }
.agencyDash-card--teal   { --c: #1a9e86; --bg: #e8faf8; }
.agencyDash-card--red    { --c: #c4243a; --bg: #fbe9eb; }

.agencyDash-card__icon img {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 50%;
  display: block;
}
.agencyDash-card__arrow {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--c);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.agencyDash-card__arrow:hover { transform: scale(1.1); }
.agencyDash-card__arrow:focus-visible { outline: 2px solid var(--c); outline-offset: 2px; border-radius: 50%; }

.agencyDash-card__body { min-width: 0; }
.agencyDash-card__title {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 500;
  color: #3f4344;
  line-height: 1.3;
}
.agencyDash-card__value {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--c);
  white-space: nowrap;
}
.agencyDash-card__bar {
  height: 4px;
  border-radius: 4px;
  background: #c9cdd2;
  overflow: hidden;
}
.agencyDash-card__bar span {
  display: block;
  width: 75%;
  height: 100%;
  border-radius: 4px;
  background: var(--c);
}

/* ---------- chart row ---------- */
.agencyDash-chart-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(250px, 0.9fr) minmax(220px, 0.65fr);
  gap: 14px;
  margin-bottom: 18px;
  align-items: stretch;
}
.agencyDash-chart-grid--budget {
  grid-template-columns: minmax(0, 1.8fr) minmax(280px, 1fr);
}

.agencyDash-chart-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 340px;
  padding: 20px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  overflow: hidden;
}
.agencyDash-chart-title { margin: 0 0 12px; font-size: 15px; font-weight: 700; color: #111; }

.agencyDash-spend { display: flex; align-items: center; gap: 10px; min-width: 0; }
.agencyDash-spend__summary { flex: 0 0 30%; min-width: 125px; max-width: 180px; }
.agencyDash-spend__amount { margin: 0; font-size: 34px; line-height: 1.1; white-space: nowrap; }
.agencyDash-spend__row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }
.agencyDash-spend__label { margin: 0; font-size: 13px; line-height: 1.3; color: darkgray; }
.agencyDash-spend__delta { margin: 0; font-size: 13px; font-weight: 700; color: #01b574; white-space: nowrap; }
.agencyDash-spend__status { margin: 8px 0 0; font-size: 15px; font-weight: 700; color: #01b574; }
.agencyDash-spend__chart { flex: 1 1 70%; min-width: 0; overflow: hidden; }

.agencyDash-taxes-chart { display: flex; align-items: center; justify-content: center; flex: 1 1; }
.agencyDash-empty-chart { padding: 40px 0; text-align: center; color: #999; }

.agencyDash-side-cards { display: flex; flex-direction: column; gap: 14px; min-width: 0; }

/* ---------- bottom panels (Vendor Bills / Head Details) ---------- */
.agencyDash-bottom-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(0, 1fr);
  gap: 14px;
}
.agencyDash-panel {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: auto;
  padding: 18px 20px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  overflow: hidden;
}
.agencyDash-panel-title { margin: 0 0 14px; font-size: 14px; font-weight: 700; color: #111; }
.agencyDash-panel-scroll { flex: 1 1 auto; min-height: 0; overflow: auto; }

.agencyDash-mini-table { width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 12px; }
.agencyDash-mini-table thead th {
  padding: 9px 8px;
  background: #2f78dc;
  color: #fff;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  border-right: 1px solid rgba(255, 255, 255, 0.45);
}
.agencyDash-mini-table thead th:last-child { border-right: none; }
.agencyDash-mini-table tbody td {
  padding: 9px 8px;
  text-align: center;
  color: #333;
  border-bottom: 1px solid #eef1f6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.agencyDash-mini-table .agencyDash-mini-empty {
  padding: 16px;
  background: #e6f2fb;
  color: #333;
  font-size: 12px;
}
.agencyDash-status { display: flex; align-items: center; gap: 6px; min-width: 0; }
.agencyDash-status img { width: 16px; height: 16px; flex-shrink: 0; object-fit: contain; }
.agencyDash-mini-bar { height: 6px; background: #e3e7ee; border-radius: 6px; overflow: hidden; }
.agencyDash-mini-bar__fill { height: 100%; width: 50%; background: #2f78dc; }

/* ---------- drill-down table page (grey shell + white card) ----------
   measured from the reference screenshot:
   shell padding 13/13/15/14 | header 36px, gap 12 | card padding 16/19
   table head 41px, rows 43px | footer text 12px bold             */
.agencyDash-table-page {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  padding: 13px 13px 15px 14px;
  background: #edf0f5;
  border-radius: 12px;
  box-sizing: border-box;
  overflow: hidden;
  font-family: Arial, Helvetica, sans-serif;
}
.agencyDash-table-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  height: 37px;
  margin-bottom: 12px;
}
.agencyDash-table-head__left { display: flex; align-items: center; gap: 14px; flex-shrink: 0; }

.agencyDash-back-btn {
  width: 36px;
  height: 37px;
  padding: 0;
  border: none;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.agencyDash-back-btn__icon {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: #0b4f99;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.agencyDash-back-btn:focus-visible { outline: 2px solid #2684ff; outline-offset: 2px; }

.agencyDash-table-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  color: #000;
  white-space: nowrap;
}

.agencyDash-search { position: relative; margin-left: auto; flex-shrink: 0; }
.agencyDash-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  width: 17px;
  height: 17px;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 4px;
  background: #e3edfb;
  transform: translateY(-50%);
  pointer-events: none;
}
.agencyDash-search-input {
  width: 224px;
  height: 30px;
  padding: 0 12px 0 39px;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  background: #fff;
  font-family: inherit;
  font-size: 12px;
  color: #111;
  outline: none;
  box-sizing: border-box;
}
.agencyDash-search-input::placeholder { color: #777; }
.agencyDash-search-input:focus { border-color: #2684ff; box-shadow: 0 0 0 1px #2684ff; }

.agencyDash-table-card {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 16px 19px 0;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}
.agencyDash-table-scroll {
  flex: 0 1 auto;
  min-height: 0;
  overflow: auto;
  border: 1px solid #a9c8ee;
  border-radius: 4px;
  position: relative;
}

.agencyDash-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.agencyDash-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  height: 41px;
  padding: 0 12px;
  background: #2f7bda;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  border-right: 1px solid #8db8ee;
}
.agencyDash-table thead th:last-child { border-right: none; }
.agencyDash-table thead th:first-child { width: 60px; }
.agencyDash-table tbody td {
  height: 43px;
  padding: 0 12px;
  background: #e4f1fb;
  color: #000;
  text-align: center;
  vertical-align: middle;
  border-right: 1px solid #f3f9fe;
  border-bottom: 1px solid #cfe3f6;
}
.agencyDash-table tbody td:last-child { border-right: none; }
.agencyDash-table tbody tr:last-child td { border-bottom: none; }
.agencyDash-table tbody tr:nth-child(even) td { background: #edf6fd; }
.agencyDash-table tbody tr:hover td { background: #d9ebfa; }
.agencyDash-table .agencyDash-cell-link { color: #5a9bd1; font-weight: 700; }
.agencyDash-table .agencyDash-cell-amount { color: #2f78dc; font-weight: 700; }
.agencyDash-table .agencyDash-link { color: #2f78dc; font-weight: 700; cursor: pointer; text-decoration: underline; }

.agencyDash-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 43px;
  background: #e4f1fb;
  color: #000;
  font-size: 12px;
}

.agencyDash-view-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5);
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
  cursor: pointer;
}

/* ---------- pagination (table pages) ---------- */
.agencyDash-pagination {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 0 20px;
}
.agencyDash-pagination-info { font-size: 12px; font-weight: 700; line-height: 14px; color: #000; white-space: nowrap; }
.agencyDash-pagination-controls { display: flex; align-items: center; gap: 22px; white-space: nowrap; }
.agencyDash-page-numbers { display: flex; align-items: center; gap: 14px; }
.agencyDash-pagination-controls button {
  padding: 0;
  border: none;
  background: transparent;
  color: #444;
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  cursor: pointer;
}
.agencyDash-pagination-controls .agencyDash-nav-btn { color: #555; }
.agencyDash-pagination-controls button:disabled { color: #b3b3b3; cursor: not-allowed; }
.agencyDash-page-numbers button.is-active { color: #2ea4e7; text-decoration: underline; }
/* small pager inside the dashboard panels */
.agencyDash-pagination--end { justify-content: flex-end; padding: 8px 0 0; }

/* ---------- photo viewer ---------- */
.agencyDash-photo-page { height: 89vh; padding: 20px 24px; background: #fff; overflow-x: hidden; overflow-y: auto; }
.agencyDash-photo-title { margin-bottom: 24px; font-size: 20px; font-weight: 700; text-align: center; }
.agencyDash-photo-lightbox {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.85);
}

/* ---------- responsive ---------- */
@media (max-width: 1200px) {
  .agencyDash-card-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .agencyDash-chart-grid,
  .agencyDash-chart-grid--budget,
  .agencyDash-bottom-grid { grid-template-columns: minmax(0, 1fr); }
}
@media (max-width: 640px) {
  .agencyDash-card-grid { grid-template-columns: minmax(0, 1fr); }
  .agencyDash-filter-group { width: 100%; justify-content: space-between; }
  .agencyDash-spend { flex-direction: column; align-items: flex-start; }
  .agencyDash-spend__summary { max-width: none; }
  .agencyDash-search-input { width: 170px; }
}

/* ---------- total row (Limit Allocation / Deduction Details) ---------- */
.agencyDash-table tbody tr.agencyDash-total-row td {
  background: #d9ebfa;
  color: #111;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/Components/admin/pages/agencydashboard.css"],"names":[],"mappings":"AAAA;;;0EAG0E;;AAE1E,qCAAqC;AACrC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,qBAAqB;EACrB,wBAAwB;AAC1B;AACA,sCAAsC,aAAa,EAAE;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA,6BAA6B,WAAW,EAAE,YAAY,EAAE;;AAExD;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;AACjD;AACA,6BAA6B,KAAK,yBAAyB,EAAE,EAAE;;AAE/D,qCAAqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB,uBAAuB;EACrB,yEAAyE;AAC3E;AACA,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC1E;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,yBAAyB,SAAW,EAAE,iBAAiB,EAAE;;AAEzD,2BAA2B,YAAY,EAAE,aAAa,EAAE;AACxD,2BAA2B,YAAY,EAAE,aAAa,EAAE;AACxD,2BAA2B,YAAY,EAAE,aAAa,EAAE;AACxD,2BAA2B,YAAY,EAAE,aAAa,EAAE;AACxD,2BAA2B,YAAY,EAAE,aAAa,EAAE;AACxD,2BAA2B,YAAY,EAAE,aAAa,EAAE;AACxD,2BAA2B,YAAY,EAAE,aAAa,EAAE;AACxD,2BAA2B,YAAY,EAAE,aAAa,EAAE;;AAExD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,gCAAgC,qBAAqB,EAAE;AACvD,wCAAwC,2BAA2B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;;AAE9G,yBAAyB,YAAY,EAAE;AACvC;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mFAAmF;EACnF,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;AAClB;AACA,0BAA0B,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAE5F,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,YAAY,EAAE;AACjF,6BAA6B,aAAa,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAChF,4BAA4B,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC/F,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACxF,2BAA2B,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC1F,2BAA2B,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC9G,4BAA4B,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAChG,2BAA2B,aAAa,EAAE,YAAY,EAAE,gBAAgB,EAAE;;AAE1E,0BAA0B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAO,EAAE;AAChG,0BAA0B,eAAe,EAAE,kBAAkB,EAAE,WAAW,EAAE;;AAE5E,yBAAyB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,YAAY,EAAE;;AAEzF,sEAAsE;AACtE;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;EACtB,gBAAgB;AAClB;AACA,0BAA0B,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAC5F,2BAA2B,cAAc,EAAE,aAAa,EAAE,cAAc,EAAE;;AAE1E,yBAAyB,WAAW,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACvG;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;AACA,6CAA6C,kBAAkB,EAAE;AACjE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE;AACjF,yBAAyB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACzF,uBAAuB,WAAW,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC/F,6BAA6B,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE;;AAE5E;;;mEAGmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;AACA,+BAA+B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;;AAE9F;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,qCAAqC,0BAA0B,EAAE,mBAAmB,EAAE;;AAEtF;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA,qBAAqB,kBAAkB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC5E;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA,wCAAwC,WAAW,EAAE;AACrD,iCAAiC,qBAAqB,EAAE,6BAA6B,EAAE;;AAEvF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB,WAAW,EAAE,yBAAyB,EAAE,eAAe,EAAE;AAC7E;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;AACA,wCAAwC,kBAAkB,EAAE;AAC5D,yCAAyC,WAAW,EAAE;AACtD;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;AAClC;AACA,wCAAwC,kBAAkB,EAAE;AAC5D,2CAA2C,mBAAmB,EAAE;AAChE,gDAAgD,mBAAmB,EAAE;AACrE,sCAAsC,mBAAmB,EAAE;AAC3D,0CAA0C,cAAc,EAAE,gBAAgB,EAAE;AAC5E,4CAA4C,cAAc,EAAE,gBAAgB,EAAE;AAC9E,qCAAqC,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE,0BAA0B,EAAE;;AAEpH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;AACtB;AACA,8BAA8B,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACtH,kCAAkC,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtG,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC1E;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA,sDAAsD,WAAW,EAAE;AACnE,kDAAkD,cAAc,EAAE,mBAAmB,EAAE;AACvF,4CAA4C,cAAc,EAAE,0BAA0B,EAAE;AACxF,4CAA4C;AAC5C,8BAA8B,yBAAyB,EAAE,gBAAgB,EAAE;;AAE3E,uCAAuC;AACvC,yBAAyB,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACnH,0BAA0B,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACtG;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA,qCAAqC;AACrC;EACE,wBAAwB,gDAAgD,EAAE;EAC1E;;4BAE0B,qCAAqC,EAAE;AACnE;AACA;EACE,wBAAwB,qCAAqC,EAAE;EAC/D,2BAA2B,WAAW,EAAE,8BAA8B,EAAE;EACxE,oBAAoB,sBAAsB,EAAE,uBAAuB,EAAE;EACrE,6BAA6B,eAAe,EAAE;EAC9C,2BAA2B,YAAY,EAAE;AAC3C;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* =====================================================================\r\n   agencydashboard.css  -  every class is prefixed with \"agencyDash-\"\r\n   Replace the WHOLE old agencydashboard.css with this file.\r\n   ===================================================================== */\r\n\r\n/* ---------- page shell ---------- */\r\n.agencyDash-page {\r\n  background: #fff;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n  font-family: Inter, \"Poppins\", sans-serif;\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n}\r\n.agencyDash-page::-webkit-scrollbar { display: none; }\r\n\r\n.agencyDash-page-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 0 0 16px 4px;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  color: #111;\r\n}\r\n.agencyDash-page-title img { width: 24px; height: 24px; }\r\n\r\n.agencyDash-loader {\r\n  margin: 80px auto;\r\n  width: 46px;\r\n  height: 46px;\r\n  border: 5px solid #dbe6f5;\r\n  border-top-color: #2563b0;\r\n  border-radius: 50%;\r\n  animation: agencyDash-spin 0.8s linear infinite;\r\n}\r\n@keyframes agencyDash-spin { to { transform: rotate(360deg); } }\r\n\r\n/* ---------- filter bar ---------- */\r\n.agencyDash-filter-bar {\r\n  position: relative;\r\n  z-index: 20;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 18px 28px;\r\n  padding: 22px 26px;\r\n  margin-bottom: 18px;\r\njustify-content: center;\r\n  background: linear-gradient(90deg, #0b5cab 0%, #073c80 55%, #04295f 100%);\r\n}\r\n.agencyDash-filter-group { display: flex; align-items: center; gap: 10px; }\r\n.agencyDash-filter-label {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ---------- stat cards ---------- */\r\n.agencyDash-card-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 18px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.agencyDash-card {\r\n  --c: #2563b0;\r\n  --bg: #eef3fa;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n  min-height: 138px;\r\n  padding: 16px 18px 18px;\r\n  border: 1.5px solid var(--c);\r\n  border-radius: 14px;\r\n  background: var(--bg);\r\n  box-sizing: border-box;\r\n}\r\n.agencyDash-card--tall { flex: 1 1 0; min-height: 150px; }\r\n\r\n.agencyDash-card--blue   { --c: #2563b0; --bg: #eef3fa; }\r\n.agencyDash-card--purple { --c: #8e3fa8; --bg: #f6f0fa; }\r\n.agencyDash-card--orange { --c: #e07a1a; --bg: #fdf7ee; }\r\n.agencyDash-card--green  { --c: #22a05a; --bg: #eaf6ee; }\r\n.agencyDash-card--pink   { --c: #c23a7c; --bg: #fbeaf1; }\r\n.agencyDash-card--indigo { --c: #2b3a8f; --bg: #e8ebf9; }\r\n.agencyDash-card--teal   { --c: #1a9e86; --bg: #e8faf8; }\r\n.agencyDash-card--red    { --c: #c4243a; --bg: #fbe9eb; }\r\n\r\n.agencyDash-card__icon img {\r\n  width: 36px;\r\n  height: 36px;\r\n  object-fit: contain;\r\n  border-radius: 50%;\r\n  display: block;\r\n}\r\n.agencyDash-card__arrow {\r\n  position: absolute;\r\n  top: 14px;\r\n  right: 14px;\r\n  width: 22px;\r\n  height: 22px;\r\n  padding: 0;\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--c);\r\n  font-size: 22px;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.agencyDash-card__arrow:hover { transform: scale(1.1); }\r\n.agencyDash-card__arrow:focus-visible { outline: 2px solid var(--c); outline-offset: 2px; border-radius: 50%; }\r\n\r\n.agencyDash-card__body { min-width: 0; }\r\n.agencyDash-card__title {\r\n  margin: 0 0 4px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #3f4344;\r\n  line-height: 1.3;\r\n}\r\n.agencyDash-card__value {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: var(--c);\r\n  white-space: nowrap;\r\n}\r\n.agencyDash-card__bar {\r\n  height: 4px;\r\n  border-radius: 4px;\r\n  background: #c9cdd2;\r\n  overflow: hidden;\r\n}\r\n.agencyDash-card__bar span {\r\n  display: block;\r\n  width: 75%;\r\n  height: 100%;\r\n  border-radius: 4px;\r\n  background: var(--c);\r\n}\r\n\r\n/* ---------- chart row ---------- */\r\n.agencyDash-chart-grid {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.65fr) minmax(250px, 0.9fr) minmax(220px, 0.65fr);\r\n  gap: 14px;\r\n  margin-bottom: 18px;\r\n  align-items: stretch;\r\n}\r\n.agencyDash-chart-grid--budget {\r\n  grid-template-columns: minmax(0, 1.8fr) minmax(280px, 1fr);\r\n}\r\n\r\n.agencyDash-chart-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  min-height: 340px;\r\n  padding: 20px;\r\n  background: #fff;\r\n  border-radius: 15px;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n}\r\n.agencyDash-chart-title { margin: 0 0 12px; font-size: 15px; font-weight: 700; color: #111; }\r\n\r\n.agencyDash-spend { display: flex; align-items: center; gap: 10px; min-width: 0; }\r\n.agencyDash-spend__summary { flex: 0 0 30%; min-width: 125px; max-width: 180px; }\r\n.agencyDash-spend__amount { margin: 0; font-size: 34px; line-height: 1.1; white-space: nowrap; }\r\n.agencyDash-spend__row { display: flex; align-items: center; gap: 8px; margin-top: 8px; }\r\n.agencyDash-spend__label { margin: 0; font-size: 13px; line-height: 1.3; color: darkgray; }\r\n.agencyDash-spend__delta { margin: 0; font-size: 13px; font-weight: 700; color: #01b574; white-space: nowrap; }\r\n.agencyDash-spend__status { margin: 8px 0 0; font-size: 15px; font-weight: 700; color: #01b574; }\r\n.agencyDash-spend__chart { flex: 1 1 70%; min-width: 0; overflow: hidden; }\r\n\r\n.agencyDash-taxes-chart { display: flex; align-items: center; justify-content: center; flex: 1; }\r\n.agencyDash-empty-chart { padding: 40px 0; text-align: center; color: #999; }\r\n\r\n.agencyDash-side-cards { display: flex; flex-direction: column; gap: 14px; min-width: 0; }\r\n\r\n/* ---------- bottom panels (Vendor Bills / Head Details) ---------- */\r\n.agencyDash-bottom-grid {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.65fr) minmax(0, 1fr);\r\n  gap: 14px;\r\n}\r\n.agencyDash-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  height: auto;\r\n  padding: 18px 20px;\r\n  background: #fff;\r\n  border-radius: 15px;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n}\r\n.agencyDash-panel-title { margin: 0 0 14px; font-size: 14px; font-weight: 700; color: #111; }\r\n.agencyDash-panel-scroll { flex: 1 1 auto; min-height: 0; overflow: auto; }\r\n\r\n.agencyDash-mini-table { width: 100%; border-collapse: collapse; table-layout: fixed; font-size: 12px; }\r\n.agencyDash-mini-table thead th {\r\n  padding: 9px 8px;\r\n  background: #2f78dc;\r\n  color: #fff;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  border-right: 1px solid rgba(255, 255, 255, 0.45);\r\n}\r\n.agencyDash-mini-table thead th:last-child { border-right: none; }\r\n.agencyDash-mini-table tbody td {\r\n  padding: 9px 8px;\r\n  text-align: center;\r\n  color: #333;\r\n  border-bottom: 1px solid #eef1f6;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.agencyDash-mini-table .agencyDash-mini-empty {\r\n  padding: 16px;\r\n  background: #e6f2fb;\r\n  color: #333;\r\n  font-size: 12px;\r\n}\r\n.agencyDash-status { display: flex; align-items: center; gap: 6px; min-width: 0; }\r\n.agencyDash-status img { width: 16px; height: 16px; flex-shrink: 0; object-fit: contain; }\r\n.agencyDash-mini-bar { height: 6px; background: #e3e7ee; border-radius: 6px; overflow: hidden; }\r\n.agencyDash-mini-bar__fill { height: 100%; width: 50%; background: #2f78dc; }\r\n\r\n/* ---------- drill-down table page (grey shell + white card) ----------\r\n   measured from the reference screenshot:\r\n   shell padding 13/13/15/14 | header 36px, gap 12 | card padding 16/19\r\n   table head 41px, rows 43px | footer text 12px bold             */\r\n.agencyDash-table-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 90vh;\r\n  padding: 13px 13px 15px 14px;\r\n  background: #edf0f5;\r\n  border-radius: 12px;\r\n  box-sizing: border-box;\r\n  overflow: hidden;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n}\r\n.agencyDash-table-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  height: 37px;\r\n  margin-bottom: 12px;\r\n}\r\n.agencyDash-table-head__left { display: flex; align-items: center; gap: 14px; flex-shrink: 0; }\r\n\r\n.agencyDash-back-btn {\r\n  width: 36px;\r\n  height: 37px;\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n.agencyDash-back-btn__icon {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 6px;\r\n  background: #0b4f99;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.agencyDash-back-btn:focus-visible { outline: 2px solid #2684ff; outline-offset: 2px; }\r\n\r\n.agencyDash-table-title {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: #000;\r\n  white-space: nowrap;\r\n}\r\n\r\n.agencyDash-search { position: relative; margin-left: auto; flex-shrink: 0; }\r\n.agencyDash-search-icon {\r\n  position: absolute;\r\n  left: 12px;\r\n  top: 50%;\r\n  width: 17px;\r\n  height: 17px;\r\n  padding: 3px;\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  background: #e3edfb;\r\n  transform: translateY(-50%);\r\n  pointer-events: none;\r\n}\r\n.agencyDash-search-input {\r\n  width: 224px;\r\n  height: 30px;\r\n  padding: 0 12px 0 39px;\r\n  border: 1px solid #e3e8ef;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  color: #111;\r\n  outline: none;\r\n  box-sizing: border-box;\r\n}\r\n.agencyDash-search-input::placeholder { color: #777; }\r\n.agencyDash-search-input:focus { border-color: #2684ff; box-shadow: 0 0 0 1px #2684ff; }\r\n\r\n.agencyDash-table-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  padding: 16px 19px 0;\r\n  background: #fff;\r\n  border-radius: 14px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\r\n  overflow: hidden;\r\n}\r\n.agencyDash-table-scroll {\r\n  flex: 0 1 auto;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  border: 1px solid #a9c8ee;\r\n  border-radius: 4px;\r\n  position: relative;\r\n}\r\n\r\n.agencyDash-table { width: 100%; border-collapse: collapse; font-size: 12px; }\r\n.agencyDash-table thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n  height: 41px;\r\n  padding: 0 12px;\r\n  background: #2f7bda;\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  border-right: 1px solid #8db8ee;\r\n}\r\n.agencyDash-table thead th:last-child { border-right: none; }\r\n.agencyDash-table thead th:first-child { width: 60px; }\r\n.agencyDash-table tbody td {\r\n  height: 43px;\r\n  padding: 0 12px;\r\n  background: #e4f1fb;\r\n  color: #000;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  border-right: 1px solid #f3f9fe;\r\n  border-bottom: 1px solid #cfe3f6;\r\n}\r\n.agencyDash-table tbody td:last-child { border-right: none; }\r\n.agencyDash-table tbody tr:last-child td { border-bottom: none; }\r\n.agencyDash-table tbody tr:nth-child(even) td { background: #edf6fd; }\r\n.agencyDash-table tbody tr:hover td { background: #d9ebfa; }\r\n.agencyDash-table .agencyDash-cell-link { color: #5a9bd1; font-weight: 700; }\r\n.agencyDash-table .agencyDash-cell-amount { color: #2f78dc; font-weight: 700; }\r\n.agencyDash-table .agencyDash-link { color: #2f78dc; font-weight: 700; cursor: pointer; text-decoration: underline; }\r\n\r\n.agencyDash-empty {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 43px;\r\n  background: #e4f1fb;\r\n  color: #000;\r\n  font-size: 12px;\r\n}\r\n\r\n.agencyDash-view-btn {\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5);\r\n  color: #fff;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n}\r\n\r\n/* ---------- pagination (table pages) ---------- */\r\n.agencyDash-pagination {\r\n  flex: 0 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 16px 0 20px;\r\n}\r\n.agencyDash-pagination-info { font-size: 12px; font-weight: 700; line-height: 14px; color: #000; white-space: nowrap; }\r\n.agencyDash-pagination-controls { display: flex; align-items: center; gap: 22px; white-space: nowrap; }\r\n.agencyDash-page-numbers { display: flex; align-items: center; gap: 14px; }\r\n.agencyDash-pagination-controls button {\r\n  padding: 0;\r\n  border: none;\r\n  background: transparent;\r\n  color: #444;\r\n  font-family: inherit;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  line-height: 14px;\r\n  cursor: pointer;\r\n}\r\n.agencyDash-pagination-controls .agencyDash-nav-btn { color: #555; }\r\n.agencyDash-pagination-controls button:disabled { color: #b3b3b3; cursor: not-allowed; }\r\n.agencyDash-page-numbers button.is-active { color: #2ea4e7; text-decoration: underline; }\r\n/* small pager inside the dashboard panels */\r\n.agencyDash-pagination--end { justify-content: flex-end; padding: 8px 0 0; }\r\n\r\n/* ---------- photo viewer ---------- */\r\n.agencyDash-photo-page { height: 89vh; padding: 20px 24px; background: #fff; overflow-x: hidden; overflow-y: auto; }\r\n.agencyDash-photo-title { margin-bottom: 24px; font-size: 20px; font-weight: 700; text-align: center; }\r\n.agencyDash-photo-lightbox {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 99999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n  background: rgba(0, 0, 0, 0.85);\r\n}\r\n\r\n/* ---------- responsive ---------- */\r\n@media (max-width: 1200px) {\r\n  .agencyDash-card-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n  .agencyDash-chart-grid,\r\n  .agencyDash-chart-grid--budget,\r\n  .agencyDash-bottom-grid { grid-template-columns: minmax(0, 1fr); }\r\n}\r\n@media (max-width: 640px) {\r\n  .agencyDash-card-grid { grid-template-columns: minmax(0, 1fr); }\r\n  .agencyDash-filter-group { width: 100%; justify-content: space-between; }\r\n  .agencyDash-spend { flex-direction: column; align-items: flex-start; }\r\n  .agencyDash-spend__summary { max-width: none; }\r\n  .agencyDash-search-input { width: 170px; }\r\n}\r\n\r\n/* ---------- total row (Limit Allocation / Deduction Details) ---------- */\r\n.agencyDash-table tbody tr.agencyDash-total-row td {\r\n  background: #d9ebfa;\r\n  color: #111;\r\n  font-weight: 700;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
